// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".editorTrustMateSection[data-v-953f943a]{margin:3rem auto 4rem}@media(max-width:768px){.editorTrustMateSection[data-v-953f943a]{margin:1rem auto 2rem}}.editorTrustMateSection__widget[data-v-953f943a]{height:430px}@media(max-width:768px){.editorTrustMateSection__widget[data-v-953f943a]{height:521px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
